import React from "react";
import { Typography } from "@mui/material";
import LocalText from "../common/LocalText";

export const MEDIA_TYPES = [
  { value: 1, label: "Image", type: "image" },
  { value: 2, label: "Video", type: "video" },
  { value: 3, label: "Audio", type: "audio" },
];

export const getPositionLabels = (count) => {
  if (count === 2) return ["Left", "Right"];
  if (count === 3) return ["Left", "Center", "Right"];
  return Array.from({ length: count }, (_, i) => `Position ${i + 1}`);
};

// True if the position has ANY content (portal link OR thumbnail).
export const positionHasContent = (position) =>
  !!position?.portalLink || position?.thumbnailLocalizations?.some((t) => (t.mediaLink ?? '').trim());

// True only when BOTH portal link AND at least one thumbnail URL are filled.
// A complete position is ready to be saved.
export const positionIsComplete = (position) =>
  !!(position?.portalLink ?? '').trim() &&
  !!(position?.thumbnailLocalizations?.some((t) => (t.mediaLink ?? '').trim()));

// True when one field is filled but the other is missing.
// Partial positions are invalid — user must either complete or clear them.
export const positionIsPartial = (position) =>
  positionHasContent(position) && !positionIsComplete(position);

export const emptyPosition = () => ({
  portalLink: "",
  thumbnailLocalizations: [{ localeId: "en_us", mediaLink: "" }],
});

export const SectionLabel = ({ children, required }) => (
  <Typography
    variant="caption"
    sx={{
      display: "block",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: 0.8,
      color: "text.secondary",
      mb: 0.5,
    }}
  >
    <LocalText>{children}</LocalText>
    {required && <span style={{ color: '#d32f2f', marginLeft: 3 }}>*</span>}
  </Typography>
);
